module.exports = __webpack_public_path__ + "img/mobile-engagement-news.562595c4.png";